import { render, staticRenderFns } from "./productNum.vue?vue&type=template&id=13642ae7"
import script from "./productNum.vue?vue&type=script&lang=js"
export * from "./productNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13642ae7')) {
      api.createRecord('13642ae7', component.options)
    } else {
      api.reload('13642ae7', component.options)
    }
    module.hot.accept("./productNum.vue?vue&type=template&id=13642ae7", function () {
      api.rerender('13642ae7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/charts/productNum.vue"
export default component.exports